import { EventEntityItem } from 'components/eventView/pages/eventData';
import { EntityListItem } from 'elements/eventView/atomic/EntityListItem';
import { useContext } from 'react';
import { CtxEventView } from 'session/ctxEventView';
import styled, { css } from 'styled-components/macro';

interface Props {
    className?: string;
    entityId: string;
    items: EventEntityItem[];
    align?: 'left' | 'center';
}

export const EntitiesList = (props: Props): JSX.Element => {
    const ctxEventView = useContext(CtxEventView);
    const { eventPath } = ctxEventView;
    const isWide = ctxEventView.isWide;

    const isSpeakerList =
        props.entityId === ctxEventView.eventData?.programSettings?.speakersListId;

    return (
        <S_EntitiesList className={props.className}>
            <S_EntityList $align={props.align} $isWide={isWide}>
                {props.items?.map((entity) => {
                    return (
                        <S_EntityListItem
                            key={entity.storyId}
                            entity={entity}
                            showDescription={isSpeakerList}
                            mobilePathTo={`/event/${eventPath}/${props.entityId}`}
                            $isWide={isWide}
                        />
                    );
                })}
            </S_EntityList>
        </S_EntitiesList>
    );
};

const S_EntitiesList = styled.div``;

const S_EntityList = styled.div<{ $isWide: boolean; $align: 'left' | 'center' }>`
    display: flex;
    flex-direction: row;
    gap: 10px;
    flex-wrap: wrap;
    overflow: hidden;
    ${(props) => {
        if (props.$isWide) {
            return css`
                gap: 20px;
            `;
        }
    }}
    ${(props) => {
        if (props.$align === 'center') {
            return css`
                justify-content: center;
            `;
        }
    }}
`;

const S_EntityListItem = styled(EntityListItem)<{ $isWide: boolean }>`
    width: calc(50% - 5px);
    min-height: 160px;
    ${(props) => {
        if (props.$isWide) {
            return css`
                width: 235px;
                // For embedded page, this fixes the max-width
                max-width: 45%;
                min-height: 221px;
            `;
        }
    }}
`;
